import { Headers } from '@angular/http';

export class APIConfig {
    public static serviceURL = 'https://swapi.co/api/films/2/';
    public static apiHeader = new Headers({ 'Content-Type': 'application/json'});

}
